import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _hoisted_1 = {
  class: "navbar navbar-light navbar-glass navbar-top navbar-expand mb-1",
  style: {"--falcon-breadcrumb-divider":"'»'"}
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<button class=\"btn navbar-toggler-humburger-icon navbar-toggler me-1 me-sm-3 ms-1\" type=\"button\" data-bs-toggle=\"collapse\" data-bs-target=\"#navbarVerticalCollapse\" aria-controls=\"navbarVerticalCollapse\" aria-expanded=\"true\" aria-label=\"Toggle Navigation\"><span class=\"navbar-toggle-icon\"><span class=\"toggle-line\"></span></span></button><a class=\"navbar-brand me-1\" href=\"/\"><div class=\"d-flex align-items-center\"><img class=\"me-2\" src=\"" + _imports_0 + "\" alt width=\"160\"></div></a>", 2)
const _hoisted_4 = { class: "nav-item breadcrumb mt-4 pt-1" }
const _hoisted_5 = { class: "breadcrumb-item" }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ol", _hoisted_4, [
      _createElementVNode("li", _hoisted_5, [
        (_ctx.breadcrumbs)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "/",
              textContent: _toDisplayString('Home')
            }, null, 8, _hoisted_6))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              textContent: _toDisplayString('Home')
            }, null, 8, _hoisted_7))
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (breadcrumb, idx) => {
        return (_openBlock(), _createElementBlock("li", {
          key: idx,
          class: _normalizeClass(["breadcrumb-item", { active: _ctx.breadcrumbs.length - 1 == idx }]),
          "aria-current": "page"
        }, [
          (_ctx.breadcrumbs.length - 1 == idx)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                textContent: _toDisplayString(breadcrumb)
              }, null, 8, _hoisted_8))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: {
            name: breadcrumb,
            params: _ctx.$route.params ? { ..._ctx.$route.params } : {},
          },
                textContent: _toDisplayString(breadcrumb)
              }, null, 8, ["to", "textContent"]))
        ], 2))
      }), 128))
    ])
  ]))
}